import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { api } from "@/lib/api";

export default function Episodes() {
  const [eps, setEps] = useState([]);
  useEffect(() => {
    api.get("/episodes").then((r) => setEps(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-12 py-24">
      <div className="text-xs uppercase tracking-[0.3em] text-[#F26A1F] mb-5">
        Season 1 · 13 Episodes
      </div>
      <h1
        className="text-5xl md:text-7xl font-black tracking-tighter leading-[0.95] mb-16"
        style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
      >
        The journey,<br />
        episode by <span className="text-[#F26A1F]">episode</span>.
      </h1>

      <div className="space-y-px bg-white/5">
        {eps.map((e) => (
          <div
            key={e.id}
            className="bg-black grid md:grid-cols-12 gap-6 p-6 md:p-8 hover:bg-white/[0.02] transition-colors group"
          >
            <div className="md:col-span-2">
              <div className="text-xs uppercase tracking-[0.25em] text-[#1E8E3E] font-bold mb-1">
                Episode
              </div>
              <div
                className="text-5xl font-black tracking-tighter text-[#F26A1F]"
                style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
              >
                {String(e.episode_number).padStart(2, "0")}
              </div>
            </div>
            <div className="md:col-span-7">
              <h2
                className="text-2xl font-bold tracking-tight mb-2"
                style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
              >
                {e.title.replace(/^E\d+:\s*/, "")}
              </h2>
              <p className="text-white/60 text-sm leading-relaxed max-w-xl">
                {e.teaser}
              </p>
            </div>
            <div className="md:col-span-3 flex md:justify-end md:items-center gap-3">
              <span className="text-[10px] uppercase tracking-[0.2em] text-[#2BA84A] font-bold">
                Stay tuned
              </span>
            </div>
            <div className="md:col-span-12 flex items-center gap-3">
              <button
                disabled
                className="h-10 px-5 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] font-bold rounded-sm border border-white/10 text-white/40 cursor-not-allowed"
              >
                <Play size={12} /> Coming Soon
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
